import { MeetingReminderProvider } from './modules/meetings/components/MeetingReminderProvider';
import { BrowserRouter, HashRouter } from "react-router";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./modules/authentication/context/AuthContext";
import { AppProvider } from "./contexts/AppContext";
import Router from "./Router";
import { Provider } from "react-redux";
import store from "./store/store";

const AppRouter =
  import.meta.env.VITE_USE_HASH_ROUTE === "true" ? HashRouter : BrowserRouter;

export default function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <AppProvider  >
          <ThemeProvider>
            <AppRouter>
              <MeetingReminderProvider><Router /></MeetingReminderProvider>
            </AppRouter>
          </ThemeProvider>
        </AppProvider>
      </AuthProvider>
    </Provider>
  );
}
